// availabilityData actions
export const SET_MULTI_ROOM = 'SET_MULTI_ROOM'
export const MULTI_ROOM_TOTAL = 'MULTI_ROOM_TOTAL'
export const CURRENT_MULTI_ROOM_STEP = 'CURRENT_MULTI_ROOM_STEP'

export const setMultiRoom = isMultiRoom => ({
	type: SET_MULTI_ROOM,
	payload: isMultiRoom
})

export const multiRoomTotal = multiRoomSteps => ({
	type: MULTI_ROOM_TOTAL,
	payload: multiRoomSteps
})

export const multiRoomCurrentStep = currentMultiRoomStep => ({
	type: CURRENT_MULTI_ROOM_STEP,
	payload: currentMultiRoomStep
})

export default function manageMultiRoom(isMultiRoom, multiRoomSteps, currentMultiRoomStep) {
	return dispatch => {
		dispatch(setMultiRoom(isMultiRoom))
		dispatch(multiRoomTotal(multiRoomSteps))
		dispatch(multiRoomCurrentStep(currentMultiRoomStep))
	}
}


// WEBPACK FOOTER //
// ./src/actions/multiRoomActions.js